import React from 'react';
import styled, { css } from 'styled-components';
import { FocusTrap } from 'focus-trap-react';

const FullSizeOverlay = styled.div(
  ({ theme }) => css`
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background: ${theme.paper.default}DD;
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 99;
  `
);

interface OverlayProps {
  children: React.ReactNode;
  onClose(): void;
}

export function Overlay({ children, onClose }: OverlayProps) {
  function handleClick(event: React.MouseEvent) {
    if (event.target === event.currentTarget) {
      onClose();
    }
  }

  return (
    <FocusTrap>
      <FullSizeOverlay id="overlay" onClick={handleClick}>
        {children}
      </FullSizeOverlay>
    </FocusTrap>
  );
}
